import { Component } from "@angular/core";

@Component({
  selector: "med-unit-info-card",
  templateUrl: "./med-unit-info-card.component.html",
  styleUrls: ["./med-unit-info-card.component.scss"],
})
export class MedUnitInfoCardComponent {}
